import { render, staticRenderFns } from "./PlansChoices.vue?vue&type=template&id=2d65e4b0"
import script from "./PlansChoices.vue?vue&type=script&lang=js"
export * from "./PlansChoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports